export const  SESSION_IS_AUTHENTICATED = false;
export const  SESSION_USERINFO = 'userinfo';
export const  SESSION_STATUS = null;